var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseIcon',{attrs:{"icon":"md-arrow-back","size":"30"},on:{"click":function($event){return _vm.RouteBack()}}}),_vm._v(" "+_vm._s(_vm.$route.params.id)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }